import NewspaperIcon from "@/assets/icons/newspaper.svg";
import Spinner from "@/components/Spinner";
import { useUser } from "@/hooks/useUser";
import { Article } from "@/types/Dashboard";
import { User } from "@/types/User";
import Typography from "@components/Typography";

import styles from "./Articles.module.css";

const Articles = (props: {
  helpArticlesError: Error | null;
  helpArticles?: Article[];
}) => {
  const { data: user } = useUser();
  const language = (user?.data as User)?.language;

  return (
    <div data-testid="dashboard--articles" className={styles.articles}>
      <div className={styles["articles__header"]}>
        <Typography
          variant="subtitle-1"
          className={styles["articles__header__title"]}
        >
          {L.DASHBOARD__ARTICLES__TITLE}
        </Typography>

        <Typography
          variant="body-1"
          className={styles["articles__header__description"]}
        >
          {L.DASHBOARD__ARTICLES__DESC}
        </Typography>
      </div>

      {props.helpArticles ? (
        <ul className={styles["articles__list"]}>
          {props.helpArticles.map((article) => {
            return (
              <li key={article.id}>
                <a
                  target="_blank"
                  href={article.translated_content[language].url || article.url}
                  rel="noopener noreferrer"
                  className={styles["articles__list__item"]}
                >
                  <NewspaperIcon width="1.5rem" />
                  <Typography
                    className={styles["articles__list__item__text"]}
                    variant="body-1"
                  >
                    {article.translated_content[language].title}
                  </Typography>
                </a>
              </li>
            );
          })}
        </ul>
      ) : props.helpArticlesError ? (
        <Typography>{L.GENERIC_ERROR}</Typography>
      ) : (
        <Spinner />
      )}
    </div>
  );
};

export default Articles;
